import { ConditionalOperator, ShowWhenConfig } from '../components/queue/conditional-field.types';

export function evaluateCondition(
  condition: ShowWhenConfig,
  formValues: Record<string, any>
): boolean {
  const fieldValue = formValues[condition.fieldKey];

  switch (condition.operator) {
    case ConditionalOperator.EQUALS:
      return fieldValue == condition.value; // non-strict
    case ConditionalOperator.NOT_EQUALS:
      return fieldValue != condition.value; // non-strict
    case ConditionalOperator.GREATER_THAN:
      return Number(fieldValue) > Number(condition.value);
    case ConditionalOperator.LESS_THAN:
      return Number(fieldValue) < Number(condition.value);
    case ConditionalOperator.GREATER_THAN_OR_EQUAL:
      return Number(fieldValue) >= Number(condition.value);
    case ConditionalOperator.HAS_VALUE:
      return fieldValue !== undefined && fieldValue !== null && fieldValue !== '' && fieldValue !== false;
    case ConditionalOperator.IS_EMPTY:
      return fieldValue === undefined || fieldValue === null || fieldValue === '' || fieldValue === false;
    default:
      return false;
  }
}
